// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"464eb914","348":"e992914f","421":"83571726","765":"b8423588","822":"1dbd79a9"}[chunkId] + ".chunk.css";
};